import { render, staticRenderFns } from "./productSeckillOrder.vue?vue&type=template&id=1a2b7a50&scoped=true"
import script from "./productSeckillOrder.vue?vue&type=script&lang=js"
export * from "./productSeckillOrder.vue?vue&type=script&lang=js"
import style0 from "./productSeckillOrder.vue?vue&type=style&index=0&id=1a2b7a50&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a2b7a50",
  null
  
)

export default component.exports